import { render, staticRenderFns } from "./myComplaintOrder.vue?vue&type=template&id=11ecbe71&scoped=true&"
import script from "./myComplaintOrder.vue?vue&type=script&lang=js&"
export * from "./myComplaintOrder.vue?vue&type=script&lang=js&"
import style0 from "./myComplaintOrder.vue?vue&type=style&index=0&id=11ecbe71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ecbe71",
  null
  
)

export default component.exports